export default value => {
    if(typeof value === 'string' || value instanceof String){
        let dateString = value.substring(0, 10);
        let date = dateString.split('-').reverse().join('.');
        return date;
    }else if(value){
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return value.toLocaleDateString('de-DE', options);
    }
}